// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"sidebar_3fZ","slidingBar":"slidingBar_WIR","slidingBarActive":"slidingBarActive_3PA","slidingBarCloseButton":"slidingBarCloseButton_2aJ","slidingBarInner":"slidingBarInner_f1N","slidingBarRow":"slidingBarRow_2nu","slidingBarRowDescription":"slidingBarRowDescription_3SZ","slidingBarFieldName":"slidingBarFieldName_1a3","slidingBarText":"slidingBarText_1YQ","slidingBarTextDescription":"slidingBarTextDescription_2z1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/side-bar/side-bar.scss
// module id = 390
// module chunks = 0 1